import React from "react";
import ChartContainer from "../chart-container";
import lang from "translations";
import { formatNumberToMoneyCurrency, getCurrencySymbol } from "services/money.service";
import classnames from "classnames";
import styles from "../dashboard-charts.module.scss";

const TotalReturnCreditsChart = ({ ...props }) => {
  const data = props.mappedData;
  return (
    <ChartContainer
      title={lang.totalReturnCredits}
      {...props}
      empty={!data.total?.value}
      emptyText={lang.noSalesInDateRange}
      className={styles.roundedChartCard}
    >
      <div className={classnames("my-sm", styles.kpiAmount)}>
        <span className={styles.kpiCurrency}>{getCurrencySymbol()}</span>
        <span className={styles.kpiNumber}>{formatNumberToMoneyCurrency(data.total?.value || 0)}</span>
      </div>
      {/* <LineChart
        height={300}
        {...data.data}
        // formatYAxis={(label) => {
        //   return formatNumberToMoneyCurrency(parseInt(label));
        // }}
        formatToolTipValue={(value) => {
          return formatNumberToMoneyWithCurrencySymbol(value.value);
        }}
      /> */}
    </ChartContainer>
  );
};

export default TotalReturnCreditsChart;
